import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { getCurrentPromotionsDataView } from "@insite/client-framework/Store/Data/Promotions/PromotionsSelectors";
import translate from "@insite/client-framework/Translate";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import ProductBrand from "@insite/content-library/Components/ProductBrand";
import ProductDescription, { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import Button from "@insite/mobius/Button";
import Checkbox from "@insite/mobius/Checkbox";
import baseTheme from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Modal, { ModalProps } from "@insite/mobius/Modal";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { selectPromotion } from "@WhiteCap/Common/Utillities/CustomTracking";
import promotionCartHandler from "@WhiteCap/Handlers/Promotions/CartPromotionHandler";
import ProductImage from "@WhiteCap/Overrides/Components/ProductImage";
import ProductPartNumbers from "@WhiteCap/Overrides/Components/ProductPartNumbers";
import CustomApplicationState from "@WhiteCap/Store/Data/CustomApplicationState/CustomApplicationState";
import React, { useEffect, useRef, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomApplicationState) => ({
    promoProducts: state.WhiteCap.promotionProducts.products,
    isLoading: state.WhiteCap.promotionProducts.isLoading,
    isCartLoading: state.WhiteCap.promotionCart.isLoading,
    promotionsDataView: getCurrentPromotionsDataView(state),
});

const mapDispatchToProps = {
    promotionCartHandler,
};

interface OwnProps {
    onHandleClose: (event?: React.SyntheticEvent) => void;
    freeQuantity: string;
    cartLines?: CartLineModel[];
    isPopupOpen: boolean;
    parentPromoProduct: CartLineModel;
    promotionType?: string;
}

export interface PromotionInerface {
    promotionPopup?: ModalProps;
    brandGridItem?: GridItemProps;
    container?: GridContainerProps;
    descriptionGridItem?: GridItemProps;
    manufacturerItem?: GridItemProps;
    cartButton?: GridItemProps;
    leftColumnGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    detailsGridItem?: GridItemProps;
    containerWrapper?: InjectableCss;
    modalFooter?: InjectableCss;
    checkboxWrapper?: GridItemProps;
    editableQuantityTextField?: TextFieldPresentationProps;
    qtyBox?: GridItemProps;
    loadingSpinner?: LoadingSpinnerProps;
    loaderWrapper?: InjectableCss;
    productDescription?: ProductDescriptionStyles;
    confirmationPopup?: InjectableCss;
    btnWrapper?: InjectableCss;
    price?: GridItemProps;
    uom?: InjectableCss;
}

export const promotionStyle: PromotionInerface = {
    promotionPopup: {
        size: 730,
        cssOverrides: {
            modalTitle: css`
                position: absolute;
                width: 100%;
                background: #fff;
                z-index: 1;

                ${({ theme }) => {
                    const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
                    return breakpointMediaQueries(theme, [
                        css`
                            h4 {
                                font-size: 17px;
                            }
                        `,
                        css`
                            h4 {
                                font-size: 17px;
                            }
                        `,
                        css``,
                        css``,
                        css``,
                    ]);
                }}
            `,
            modalContent: css`
                padding-top: 80px;
                margin-bottom: 30px;
                overflow-y: auto;
                ${({ theme }) => {
                    const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
                    return breakpointMediaQueries(theme, [
                        css`
                            padding: 80px 18px 30px 18px;
                        `,
                        css`
                            padding: 80px 18px 30px 18px;
                        `,
                        css``,
                        css``,
                        css``,
                    ]);
                }}
                > div:first-of-type[class^="GridWrapper"] {
                    height: calc(84vh - 80px);
                    ${({ theme }) => {
                        const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
                        return breakpointMediaQueries(theme, [
                            css`
                                height: calc(91vh - 100px);
                            `,
                            css`
                                height: calc(91vh - 100px);
                            `,
                            css``,
                            css``,
                            css``,
                        ]);
                    }}
                }
            `,
        },
    },
    containerWrapper: {
        css: css`
            display: flex;
            border-bottom: 1px solid ${getColor("common.border")};
            &.disabled {
                opacity: 0.5;
                pointer-events: none;
            }
            &:last-child {
                border-bottom: 0;
            }
            ${({ theme }) => {
                const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
                return breakpointMediaQueries(theme, [
                    css`
                        padding-bottom: 20px;
                    `,
                    css`
                        padding-bottom: 20px;
                    `,
                    css``,
                    css``,
                    css``,
                ]);
            }}
        `,
    },
    detailsGridItem: {
        width: [12, 12, 12, 12, 12],
    },
    brandGridItem: {
        width: [12, 12, 12, 12, 12],
        css: css`
            padding: 30px 0 5px 0;
        `,
    },
    descriptionGridItem: {
        width: 12,
        css: css`
            padding: 5px 0 0;
        `,
    },
    manufacturerItem: {
        width: [12, 12, 12, 7, 7],
        css: css`
            padding: 5px 0 0;
        `,
    },
    container: {
        gap: 10,
        css: css`
            width: 100%;
        `,
    },
    cartButton: {
        width: [12, 12, 12, 5, 5],
        css: css`
            align-items: center;
            padding: 15px 0;
            justify-content: center;
            ${({ theme }) => {
                const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
                return breakpointMediaQueries(theme, [
                    css`
                        justify-content: flex-start;
                    `,
                    css`
                        justify-content: flex-start;
                    `,
                    css``,
                    css``,
                    css``,
                ]);
            }}
        `,
    },
    leftColumnGridItem: {
        width: [5, 5, 5, 3, 3],
        css: css`
            padding-right: 40px;
            padding-left: 20px;
            flex-direction: column;
            justify-content: center;
            a[data-test-selector="productImage"] {
                max-width: 100px;
                max-height: 140px;
            }
            ${({ theme }) => {
                const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
                return breakpointMediaQueries(theme, [
                    css`
                        padding-right: 34px;
                        padding-left: 0px;
                    `,
                    css`
                        padding-right: 34px;
                        padding-left: 0px;
                    `,
                    css``,
                    css``,
                    css``,
                ]);
            }}
        `,
    },
    rightColumnGridItem: {
        width: [12, 12, 12, 10, 10],
    },
    modalFooter: {
        css: css`
            position: fixed;
            width: 730px;
            left: 50%;
            transform: translateX(-50%);
            z-index: 2000;
            background-color: white;
            padding: 1rem 2rem;
            border-top: 1px solid ${getColor("common.border")};
            display: flex;
            justify-content: center;
            gap: 1rem;
            ${({ theme }) => {
                const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
                return breakpointMediaQueries(theme, [
                    css`
                        bottom: 0;
                    `,
                    css`
                        bottom: 0;
                    `,
                    css``,
                    css``,
                    css``,
                ]);
            }}
        `,
    },
    checkboxWrapper: {
        css: css`
            align-items: center;
            justify-content: center;
            width: 1%;
            max-width: 1%;
            margin-right: 15px !important;
            div[data-id="checkbox"] {
                cursor: pointer;
                box-shadow: 0px 0px 0px 1px #000;
                border-radius: 4px;
            }
        `,
    },
    editableQuantityTextField: {
        labelProps: {
            variant: "legend",
            css: css`
                font-size: 10px;
                text-transform: uppercase;
                font-weight: 600;
            `,
        },
    },
    qtyBox: {
        width: [6, 6, 6, 3, 3],
        css: css`
            padding: 15px 0 30px 0;
            div[class^="FormFieldStyle"] {
                flex-direction: row;
                align-items: center;
                label {
                    width: 82px;
                }
                div[class^="FormInputWrapper"] {
                    margin-top: 0px;
                }
            }
        `,
    },
    loadingSpinner: {
        size: 40,
        css: css`
            margin-top: auto;
            margin-bottom: auto;
        `,
    },
    loaderWrapper: {
        css: css`
            display: flex;
            justify-content: center;
            align-items: center;
            height: calc(84vh - 80px);
            ${({ theme }) => {
                const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
                return breakpointMediaQueries(theme, [
                    css`
                        height: calc(91vh - 100px);
                    `,
                    css`
                        height: calc(91vh - 100px);
                    `,
                    css``,
                    css``,
                    css``,
                ]);
            }}
        `,
    },
    confirmationPopup: {
        css: css`
            height: calc(84vh - 85px);
            display: flex;
            align-items: center;
            justify-content: center;
            span {
                font-size: 18px;
                line-height: 24px;
                font-weight: 500;
                text-align: center;
            }
            ${({ theme }) => {
                const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
                return breakpointMediaQueries(theme, [
                    css`
                        height: calc(91vh - 100px);
                    `,
                    css`
                        height: calc(91vh - 100px);
                    `,
                    css``,
                    css``,
                    css``,
                ]);
            }}
        `,
    },
    btnWrapper: {
        css: css`
            display: flex;
        `,
    },
    price: {
        css: css`
            padding: 5px 0 0;
            font-weight: 600;
            span {
                font-weight: 400;
            }
        `,
    },
    uom: {
        css: css`
            font-weight: 400;
            margin-left: 5px;
        `,
    },
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const styles = promotionStyle;

const PromotionPopup: React.FC<Props> = ({
    onHandleClose,
    promoProducts,
    freeQuantity,
    promotionCartHandler,
    isLoading,
    isCartLoading,
    cartLines,
    isPopupOpen,
    promotionType,
    promotionsDataView,
    parentPromoProduct,
}) => {
    const [quantities, setQuantities] = useState<{ [productId: string]: number }>({});
    const totalFreeQty = Number(freeQuantity);
    const [selectedProducts, setSelectedProducts] = useState<{ [productId: string]: boolean }>({});
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const isEolPromotion = promotionType === "EOL";
    const isSubmittingRef = useRef(false);

    React.useEffect(() => {
        if (isSubmittingRef.current && !isCartLoading) {
            isSubmittingRef.current = false;
            onHandleClose();
        }
    }, [isCartLoading]);

    React.useEffect(() => {
        if (!isPopupOpen) {return;}

        const initialSelected: Record<string, boolean> = {};
        const initialQuantities: Record<string, number> = {};

        promoProducts.forEach(product => {
            // Find the cart line that was added from the popup (child item)
            const promoCartLine = cartLines?.find(
                line => line.productId === product.id && !!line.properties?.choiceOfFreeProductPromotionId, // must have a value
            );

            const qty = promoCartLine?.qtyOrdered ?? 0;

            if (isEolPromotion) {
                // In EOL, only select if it was explicitly added from popup
                if (promoCartLine) {
                    initialSelected[product.id] = qty > 0;
                    initialQuantities[product.id] = qty;
                } else {
                    initialSelected[product.id] = false;
                    initialQuantities[product.id] = 0;
                }
            } else {
                // For non-EOL, follow same logic — show only items added via popup
                if (promoCartLine) {
                    initialSelected[product.id] = qty > 0;
                    initialQuantities[product.id] = qty;
                } else {
                    initialSelected[product.id] = false;
                    initialQuantities[product.id] = 0;
                }
            }
        });

        setSelectedProducts(initialSelected);
        setQuantities(initialQuantities);
    }, [isPopupOpen, cartLines, promoProducts, isEolPromotion]);

    const handleCheckboxChange = (productId: string, isChecked: boolean) => {
        setSelectedProducts(prev => ({
            ...prev,
            [productId]: isChecked,
        }));

        if (isChecked) {
            setQuantities(prev => ({
                ...prev,
                [productId]: 1,
            }));
        } else {
            setQuantities(prev => ({
                ...prev,
                [productId]: 0,
            }));
        }
    };

    const handleQtyChange = (productId: string, qty: string) => {
        if (qty === "") {
            // Allow blank input temporarily without unchecking or updating quantity
            setQuantities(prev => ({
                ...prev,
                [productId]: 0,
            }));
            return;
        }

        const parsedQty = Number(qty);

        if (!isNaN(parsedQty) && parsedQty >= 0) {
            const totalWithoutCurrent = Object.entries(quantities).reduce((sum, [id, q]) => {
                if (id === productId || !selectedProducts[id]) {return sum;}
                return sum + Number(q);
            }, 0);

            const totalWithNew = totalWithoutCurrent + parsedQty;
            if (totalWithNew > totalFreeQty) {return;}

            setQuantities(prev => ({
                ...prev,
                [productId]: parsedQty,
            }));

            setSelectedProducts(prev => ({
                ...prev,
                [productId]: parsedQty > 0,
            }));
        }
    };

    // EC-1220 Start :- Setup custom message for the selection of free choice of products if not selected
    const totalSelectedQty = Object.entries(quantities).reduce((sum, [productId, qty]) => {
        return selectedProducts[productId] ? sum + qty : sum;
    }, 0);

    const isAddToCartEnabled = totalSelectedQty > 0 && totalSelectedQty <= totalFreeQty;

    const addToCartHandler = () => {
        if (totalSelectedQty !== totalFreeQty) {
            setShowConfirmModal(true);
        } else {
            handleAddToCart();
        }
    };

    // EC-1220 End :- Setup custom message for the selection of free choice of products if not selected

    const handleAddToCart = () => {
        setShowConfirmModal(false);
        const filteredProducts = promoProducts
            .filter(item => selectedProducts[item.id])
            .filter(item => (quantities[item.id] ?? 0) > 0)
            .map(item => ({
                ...item,
                qty: quantities[item.id] ?? 0,
            }));

        isSubmittingRef.current = true;
        promotionCartHandler({ products: filteredProducts } as any);

        if (filteredProducts.length) {
            const itemsData = [];
            
            for (let index = 0; index < filteredProducts.length; index++) {
                itemsData.push({
                    item_id: filteredProducts[index].productNumber,
                    item_name: filteredProducts[index].productTitle,
                    price: filteredProducts[index].unitListPrice,
                    quantity: filteredProducts[index].qty,
                    item_brand: filteredProducts[index].brand?.name || "",
                });
            }

            const selectedPromotion = promotionsDataView.value?.filter(
                promo => promo.orderLineId === parentPromoProduct.id,
            )[0];

            selectPromotion({
                event: "select_promotion",
                promotion_id: selectedPromotion?.id.split(":")[0] || "",
                promotion_name: selectedPromotion?.promotionResultType || "",
                items: itemsData,
            });
        }
    };

    return (
        <>
            <Modal
                isOpen
                headline={`${translate("Choose_Free_Product_Title", totalFreeQty.toString())}`}
                handleClose={!isLoading && !isCartLoading ? onHandleClose : undefined}
                {...styles.promotionPopup}
            >
                {isLoading || isCartLoading ? (
                    // Show Loader
                    <StyledWrapper {...styles.loaderWrapper}>
                        <LoadingSpinner {...styles.loadingSpinner} />
                    </StyledWrapper>
                ) : showConfirmModal ? (
                    <>
                        <StyledWrapper {...styles.confirmationPopup}>
                            <Typography as="span">
                                {translate("Quantity_Under_Free_Threshold_Confirmation", totalFreeQty.toString())}
                            </Typography>
                        </StyledWrapper>
                        <StyledWrapper {...styles.modalFooter}>
                            <Button variant="primary" onClick={() => setShowConfirmModal(false)}>
                                {translate("No")}
                            </Button>
                            <Button variant="secondary" onClick={handleAddToCart}>
                                {translate("Yes")}
                            </Button>
                        </StyledWrapper>
                    </>
                ) : (
                    <>
                        <GridContainer {...styles.container}>
                            {promoProducts?.map((product, index) => (
                                <StyledWrapper
                                    key={product.id || index}
                                    {...styles.containerWrapper}
                                    className={product.cantBuy ? "disabled" : ""}
                                >
                                    <GridItem {...styles.checkboxWrapper}>
                                        <Checkbox
                                            checked={selectedProducts[product.id] ?? false}
                                            onChange={(_, isChecked) => {
                                                handleCheckboxChange(product.id, isChecked);
                                            }}
                                        />
                                    </GridItem>
                                    <GridItem {...styles.leftColumnGridItem}>
                                        <ProductImage
                                            product={{
                                                ...(product as unknown as ProductContextModel),
                                                productUri: product.canonicalUrl,
                                            }}
                                        />
                                    </GridItem>
                                    <GridItem {...styles.rightColumnGridItem}>
                                        <GridContainer>
                                            <GridItem {...styles.detailsGridItem}>
                                                <GridContainer>
                                                    <GridItem width={12} {...styles.brandGridItem}>
                                                        {product.brand && <ProductBrand brand={product.brand} />}
                                                    </GridItem>
                                                    <GridItem width={12} {...styles.descriptionGridItem}>
                                                        <ProductDescription
                                                            product={{
                                                                ...(product as unknown as ProductContextModel),
                                                                description: product.productTitle,
                                                                productUri: product.canonicalUrl,
                                                            }}
                                                            extendedStyles={styles.productDescription}
                                                        />
                                                    </GridItem>
                                                    <GridItem width={12} {...styles.manufacturerItem}>
                                                        <ProductPartNumbers
                                                            productNumber={product.productNumber}
                                                            manufacturerItem={product.manufacturerItem}
                                                        />
                                                    </GridItem>
                                                    {isEolPromotion && (
                                                        <GridItem width={12} {...styles.price}>
                                                            <StyledWrapper as="span">
                                                                {translate("PRICE: ")}
                                                            </StyledWrapper>
                                                            {product.unitListPriceDisplay}
                                                            {product.unitOfMeasure && (
                                                                <StyledWrapper {...styles.uom}>
                                                                    {" "}
                                                                    ({product.unitOfMeasure})
                                                                </StyledWrapper>
                                                            )}
                                                        </GridItem>
                                                    )}
                                                </GridContainer>
                                            </GridItem>
                                            <GridItem width={12} {...styles.qtyBox}>
                                                <TextField
                                                    type="number"
                                                    label={translate("QTY")}
                                                    min={0}
                                                    max={totalFreeQty}
                                                    value={quantities[product.id]?.toString() ?? "0"}
                                                    // value={(quantities[product.id] ?? 0).toString()}
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                                        handleQtyChange(product.id, e.target.value)
                                                    }
                                                    onKeyDown={event => {
                                                        const blockedKeys = [".", ",", "e", "-", "+"];
                                                        if (blockedKeys.includes(event.key)) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                    disabled={!selectedProducts[product.id]}
                                                    inputMode="numeric"
                                                    pattern="\d*"
                                                />
                                            </GridItem>
                                        </GridContainer>
                                    </GridItem>
                                </StyledWrapper>
                            ))}
                        </GridContainer>

                        <StyledWrapper {...styles.modalFooter}>
                            <Button variant="primary" onClick={addToCartHandler} disabled={!isAddToCartEnabled}>
                                {translate("Add To Cart")}
                            </Button>
                        </StyledWrapper>
                    </>
                )}
            </Modal>
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(PromotionPopup);